/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_OrganizationResponse } from '../models/models_OrganizationResponse';
import type { models_OrganizationsListResponse } from '../models/models_OrganizationsListResponse';
import type { orgusers_CreateOrgUserRequest } from '../models/orgusers_CreateOrgUserRequest';
import type { orgusers_OrganizationUser } from '../models/orgusers_OrganizationUser';
import type { orgusers_OrganizationUsersResponse } from '../models/orgusers_OrganizationUsersResponse';
import type { orgusers_ResetPasswordRequest } from '../models/orgusers_ResetPasswordRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrganizationsService {
    /**
     * List organizations
     * Returns a paginated list of organizations
     * @param page Page number for pagination
     * @param pageSize Number of items per page (max 200)
     * @param search Search in organization names
     * @param active Filter by active organizations
     * @returns models_OrganizationsListResponse OK
     * @throws ApiError
     */
    public static getOrganizations(
        page?: number,
        pageSize?: number,
        search?: string,
        active?: boolean,
    ): CancelablePromise<models_OrganizationsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
                'active': active,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieve organization
     * Returns details of a specific organization by ID
     * @param id Organization ID
     * @returns models_OrganizationResponse OK
     * @throws ApiError
     */
    public static getOrganizations1(
        id: string,
    ): CancelablePromise<models_OrganizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * List organization users
     * Returns users belonging to the given organization
     * @param organizer Organizer slug
     * @returns orgusers_OrganizationUsersResponse OK
     * @throws ApiError
     */
    public static getOrganizersUsers(
        organizer: string,
    ): CancelablePromise<orgusers_OrganizationUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/users',
            path: {
                'organizer': organizer,
            },
        });
    }
    /**
     * Create organization user
     * @param organizer Organizer slug
     * @param body New user
     * @returns orgusers_OrganizationUser Created
     * @throws ApiError
     */
    public static postOrganizersUsers(
        organizer: string,
        body: orgusers_CreateOrgUserRequest,
    ): CancelablePromise<orgusers_OrganizationUser> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/users',
            path: {
                'organizer': organizer,
            },
            body: body,
        });
    }
    /**
     * Update organization user
     * @param organizer Organizer slug
     * @param userId User ID
     * @returns orgusers_OrganizationUser OK
     * @throws ApiError
     */
    public static putOrganizersUsers(
        organizer: string,
        userId: string,
    ): CancelablePromise<orgusers_OrganizationUser> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/users/{userId}',
            path: {
                'organizer': organizer,
                'userId': userId,
            },
        });
    }
    /**
     * Delete organization user
     * @param organizer Organizer slug
     * @param userId User ID
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersUsers(
        organizer: string,
        userId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/users/{userId}',
            path: {
                'organizer': organizer,
                'userId': userId,
            },
        });
    }
    /**
     * Reset organization user password
     * @param organizer Organizer slug
     * @param userId User ID
     * @param body New password
     * @returns void
     * @throws ApiError
     */
    public static postOrganizersUsersResetPassword(
        organizer: string,
        userId: string,
        body: orgusers_ResetPasswordRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/users/{userId}/reset-password',
            path: {
                'organizer': organizer,
                'userId': userId,
            },
            body: body,
        });
    }
}
